<template>
  <div class="get_quote_action">
    <button @click="active = true"><slot></slot></button>
    <inline-modal container-class="quote-request-modal" :requested="active" @modal-closed="close()">
      <section v-if="active && !viewSuccess" class="configurator-quote">
        <div class="quote-intro">
          <h2>Get a Quote</h2>
          <p>Complete the form below and a LightArt sales representative will get in touch with you soon.</p>
        </div>

        <sku-selector
          v-show="!viewForm"
          :clipboard="configurations"
          @update-selections="updateSelections"
        />

        <request-form
          v-if="!stepped || viewForm"
          :selections="selections"
          ref="requestFormComponent"
          @successful-submission="setViewSuccess"
          :configurationPricing="configurationPricing"
        />

        <div class="quote-actions">
          <button type="button" v-if="!viewForm"  @click="active=false" class="secondary">Cancel</button>
          <button type="button" v-if="stepped && viewForm" @click="viewForm=false" class="secondary">Back</button>
          <button type="button" v-if="stepped && !viewForm" :disabled="continueButtonDisabled" @click="viewForm=true" class="primary">Continue</button>
          <button type="submit" v-if="viewForm || !stepped" @click="$refs.requestFormComponent.submit()" class="primary">Submit</button>
        </div>
      </section>
      <section v-if="active && viewForm && viewSuccess" class="configurator-quote success">
        <img src="/assets/images/theme/icon_checksuccess.svg" alt="Success">
        <h2>Thank You!</h2>
        <p>A LightArt sales representative will reach out with a quote shortly. Feel free to <a href="/contact">contact</a> us directly if you need an immediate response.</p>
        <button @click="complete()" type="button">Back to LightArt</button>
      </section>
    </inline-modal>
  </div>
</template>

<script>
import currencyFormatter from '../../currency_formatter'
import InlineModal from '../InlineModal'
import RequestForm from './quote-request/RequestForm'
import SkuSelector from './quote-request/SkuSelector'

export default {
  components: {
    InlineModal,
    RequestForm,
    SkuSelector
  },
  props: [
    'configurations',
  ],
  data() {
    return {
      active: false,
      viewForm: false,
      currencyFormatter,
      viewSuccess: false,
      selections: new Map(),
      configurationPricing: [],
      continueButtonDisabled: true,
    }
  },
  computed: {
    stepped: function() {
      return this.configurations.length > 1;
    },
  },
  methods: {
    updateSelections(index, vals) {
      if (this.selections.has(index)) {
        this.selections.set(index, vals[index]);
      } else if (vals[index].qty === 0) {
        this.selections.delete(index);
      } else {
        this.selections.set(index, vals[index]);
      }

      this.updateConfigurationPricing();
      this.continueButtonDisabled = (this.selections.size < 1 && this.stepped);
    },
    updateConfigurationPricing() {
      const allConfigurationsWithPrice = [];

      for (const config of this.configurations) {
        const { selections, id, product: { steps, productBasePrice } } = config; /* theres like 10 steps with ~2+ options each */

        if (this.selections.has(id)) {
          let totalPrice = productBasePrice;
          const optionSkuToPrice = {};
          const selectionSkus = Object.values(selections);

          selectionSkus.forEach((sku) => {
            steps.forEach((step) => {
              step.options.forEach((option) => {
                if (option.sku === sku) {
                  totalPrice += option.price;
                  optionSkuToPrice[sku] = (option.price ? currencyFormatter(option.price) : null);
                }
              });
            });
          });

          optionSkuToPrice['productBasePrice'] = currencyFormatter(productBasePrice);
          optionSkuToPrice['totalPrice'] = currencyFormatter(totalPrice);

          allConfigurationsWithPrice.push(optionSkuToPrice);
        }
      }
      this.configurationPricing = allConfigurationsWithPrice;
    },
    complete() {
      this.close();
      this.$emit('completed');
    },
    close() {
      this.active = false;
      this.viewSuccess = false;
      this.selections.clear();
      this.continueButtonDisabled = true;
    },
    setViewSuccess() {
      this.viewForm = true;
      this.viewSuccess = true;
    }
  }
}
</script>
